<template>
  <div>
    <InvoiceTemplateTable
      
    />

  </div>
</template>

<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';
import InvoiceTemplateTable from '@/view/pages/ml/invoices/InvoiceTemplateTable.vue';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';


export default {
  name: 'InvoiceTemplateTab',
  mixins: [ toasts ],
  components: {
    InvoiceTemplateTable,
  },
  computed: {
    ...mapGetters(['currentCompanyId']),
  },
  methods: {
    
  },

  mounted() {
    
  },

  data() {
    return {
      
    };
  }
};

</script>
